class ShortcutHint {
  constructor(public shortcutId: number, public modalGuid: string) {
  }
}

export { ShortcutHint };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/tombola-shortcut-overlay/_domain/models/shortcut-hint.ts